import React from "react";
import styles from "./HomeBottomLast.module.css";
import {IoLogoLinkedin} from 'react-icons/io';
import {ImTwitter} from 'react-icons/im';
import {AiFillInstagram} from 'react-icons/ai';
import {IoLogoFacebook} from 'react-icons/io';

export default function HomeBottomLast() {
  return (
    <div className={styles.main}>
      <div className={styles.mainCont}>
        <div className={styles.dataCont}>
          <div>
            <h1 className={styles.head}>Contact us</h1><br />
            <h1 className={styles.head}>About us</h1><br />
            <h1 className={styles.head}>Our mission</h1><br />
          </div>
          <div className={styles.add}>
            <h1 className={styles.head}>Our address</h1><br />
            <p className={styles.pera}>3, oladele close off makarios street,<br />Ajah, Lagos,<br />Nigeria</p>
          </div>
        </div>
        <hr className={styles.line} />
        <div className={styles.icons}>
            <IoLogoLinkedin className={styles.icon} />
            <ImTwitter className={styles.icon} />
            <AiFillInstagram className={styles.icon} />
            <IoLogoFacebook className={styles.icon} />
        </div>
        <p className={styles.social}>We are social</p>
      </div>
      
    </div>
  );
}
